<template>
  <div>
    <notifications style="top: 80px; z-index: 10000" />
    <HvhModal :value="true" :title="$store.state.modalConfirm.title" @input="$store.state.modalConfirm.reject" v-if="$store.state.modalConfirm.show">
      <template v-slot>
        <p v-for="(spl, ind) in ($store.state.modalConfirm.message || '').split('\n')" :key="ind">
          {{ spl }}
        </p>
        <v-form @submit.prevent v-if="$store.state.modalConfirm.optionMessage || $store.state.modalConfirm.optionComponent" ref="frm">
          <component :is="$store.state.modalConfirm.optionComponent || 'v-text-field'" :label="$store.state.modalConfirm.optionMessage" v-model="$store.state.modalConfirm.option" :rules="$store.state.modalConfirm.optionRequired && requiredRules" />
        </v-form>
      </template>
      <template v-slot:actions>
        <v-tooltip top v-if="$store.state.modalConfirm.cancelTitle">
          <v-btn flat="flat" @click="$store.state.modalConfirm.reject" slot="activator">{{ $store.state.modalConfirm.cancelText }}</v-btn>
          <span>{{ $store.state.modalConfirm.cancelTitle }}</span>
        </v-tooltip>
        <v-btn flat="flat" @click="$store.state.modalConfirm.reject" v-else>{{ $store.state.modalConfirm.cancelText }}</v-btn>

        <v-tooltip top v-if="$store.state.modalConfirm.okTitle">
          <v-btn flat="flat" @click="resolve" slot="activator">{{ $store.state.modalConfirm.okText }}</v-btn>
          <span>{{ $store.state.modalConfirm.okTitle }}</span>
        </v-tooltip>
        <v-btn class="suisse-intl-regular" flat="flat" @click="resolve" v-else>{{ $store.state.modalConfirm.okText }}</v-btn>
      </template>
    </HvhModal>
    <HvhModal :value="true" :title="$store.state.modalAlert.title" @input="$store.state.modalAlert.resolve" v-if="$store.state.modalAlert.show">
      <template v-slot>
        <p v-for="(spl, ind) in ($store.state.modalAlert.message || '').split('\n')" :key="ind">
          {{ spl }}
        </p>
      </template>
    </HvhModal>
    <RightClickMenu v-if="$store.state.rightClickEvent" />
  </div>
</template>

<script>
import HvhModal from '../modal/HvhModal.vue'
import RightClickMenu from '../contextMenu/RightClickMenu.vue';
export default {
  components: { HvhModal, RightClickMenu },
  data() {
    return {
      requiredRules: [v => !!v || v === false || v == 0 || 'Field is required'],
    };
  },
  methods: {
    resolve() {
      if (this.$refs.frm && !this.$refs.frm.validate())
        return;
      this.$store.state.modalConfirm.resolve();
    },
  }
}
</script>

<style lang="scss" scoped>
.vue-notification-group {
  top: 80px;
}
</style>